import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';


/**
 * A component to protect routes that require authentication.
 * If the user is not authenticated, it redirects them to the login page,
 * saving the location they were trying to access.
 * Otherwise, it renders the child routes.
 */
const ProtectedRoute: React.FC = () => {
    const location = useLocation();

    if (!isAuthenticated()) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;